const constants = {
    login: "/my-scholastic/sign-in.html?ref=pportal",
    bf: "/content/fairs/home.html",
}

export default constants;